import { render } from "./HeroiconsOutlineChevronDoubleDown.vue?vue&type=template&id=ebd017fa"
const script = {}

import exportComponent from "/Users/larkinwhitaker/Projects/eye-rep/modules/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChevronDoubleDown.vue"]])

export default __exports__